import { Center, Spinner } from "@reverb-ui/react";
import { createContext, useEffect, useState } from "react";
import { Userpilot } from 'userpilot';

import { decodeJWT } from "helper/genericHelper";
import { makeAuthDatasource } from "main/factories/datasources/auth-datasource-factory";

export type AuthContext = {
  token?: string;
  loading?: boolean;
  resetAllField: () => void;
};

const initContext: AuthContext = { resetAllField: () => {} };

export const GlobalAuthContext = createContext(initContext);

type AuthProviderProps = {
  children: React.ReactNode;
};

const emitSizeChange = () => {
  window.parent.postMessage(
    {
      action: "INSIGHTS_RESIZE",
      payload: {
        height: document.body.clientHeight,
      },
    },
    "*"
  );
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [token, setToken] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(true);
  const authDataSource = makeAuthDatasource();

  const getUrlParamsToken = () : string => {
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get("token") ?? urlParams.get("Token");

    return authToken ?? '';
  }

  const login = async () => {
    try {
      setLoading(true);
      const authToken = getUrlParamsToken();
      setToken(authToken);
      authDataSource.setToken(authToken ?? '')
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    login();
    new ResizeObserver(emitSizeChange).observe(document.body);
  }, []);

  useEffect(() => {
    try {
      const userData = decodeJWT(token);
      const { email, ...data } = userData;

      if (!email) return Userpilot.anonymous();

      return Userpilot.identify(email, data);
    } catch {
      Userpilot.anonymous();
    }
  }, [token]);

  const values = {
    token,
    loading,
    resetAllField: () => {},
  };

  return (
    <GlobalAuthContext.Provider value={values}>
      {loading && (
        <Center mt={6}>
          <Spinner size="xl" color="blue.500" />
        </Center>
      )}

      {!loading && children}
    </GlobalAuthContext.Provider>
  );
};

export default AuthProvider;
